import { render, staticRenderFns } from "./Actor.vue?vue&type=template&id=5b47a00c&scoped=true&"
import script from "./Actor.vue?vue&type=script&lang=js&"
export * from "./Actor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47a00c",
  null
  
)

export default component.exports